var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 24,
    viewBox: "0 0 39 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2065_5637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8496 11.9998C14.8496 15.8998 16.6496 19.1998 19.4996 21.4498C22.1996 19.1998 23.9996 15.8998 23.9996 11.9998C23.9996 8.09981 22.1996 4.7998 19.3496 2.5498C16.6496 4.7998 14.8496 8.09981 14.8496 11.9998Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.65 19.0504H37.8V18.9004H37.5V19.0504H37.65ZM38.4 19.5004V19.0504H38.25L38.1 19.3504L37.95 19.0504H37.8V19.5004H37.95V19.2004L38.1 19.5004H38.25L38.4 19.2004V19.5004Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8496 0C23.9996 0 21.4496 0.9 19.4996 2.55C22.1996 4.8 23.9996 8.1 23.9996 12C23.9996 15.9 22.1996 19.2 19.3496 21.45C21.4496 23.1 23.9996 24 26.6996 24C33.2996 24 38.6996 18.6 38.6996 12C38.8496 5.4 33.4496 0 26.8496 0Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.85 12C14.85 8.1 16.65 4.8 19.5 2.55C17.4 0.9 14.85 0 12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24C14.85 24 17.4 23.1 19.35 21.45C16.65 19.2 14.85 15.9 14.85 12Z",
    fill: "#EB001B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2065_5637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.85,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.ccd5a9b9a9e6647b9c0aa5dc4bbb19f8.svg";
export { ForwardRef as ReactComponent };